import bathing from '../../assets/icons/activities/bathing.svg';
import changingClothes from '../../assets/icons/activities/changing_clothes.png';
import holdingClothed from '../../assets/icons/activities/holding_clothed.png';
import mouthCare from '../../assets/icons/activities/mouth_care.png';
import other from '../../assets/icons/activities/other.png';
import reading from '../../assets/icons/activities/reading.png';
import singing from '../../assets/icons/activities/singing.png';
import skinToSkin from '../../assets/icons/activities/skin_to_skin.png';
import talking from '../../assets/icons/activities/talking.png';
import temperature from '../../assets/icons/activities/temperature.png';
import timeInNICU from '../../assets/icons/activities/time_in_nicu.png';
import tummyTime from '../../assets/icons/activities/tummy_time.png';

export default {
    bathing,
    changingClothes,
    holdingClothed,
    mouthCare,
    reading,
    singing,
    skinToSkin, 
    talking,
    temperature,
    timeInNICU,
    tummyTime,
    other,
}


// WEBPACK FOOTER //
// ./src/components/icons/activityIcons.js